import { gql } from '@apollo/client';
import { useState } from 'react';
import { Input, inputClassNames } from './input';
import { useSearchProductsLazyQuery } from 'lib/graphql-generated';
import { load } from 'dotenv/types';
import { Spinner } from 'components/spinner';

interface Props {
  value: {
    id: string;
    name: string;
    price: number;
  };
  setValue: ({
    id,
    name,
    price,
  }: {
    id: string;
    name: string;
    price: number;
  }) => any;
  id: string;
}

const SEARCH_PRODUCTS = gql`
  query SearchProducts($search: String) {
    products(
      where: {
        _and: [{ title: { _ilike: $search } }, { is_sub: { _eq: false } }]
      }
    ) {
      id
      title
      price
    }
  }
`;

export const SingleProductSelector = ({ value, setValue, id }: Props) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [search, { data, loading }] = useSearchProductsLazyQuery();

  const handleSearch = (v) => {
    setSearchValue(v);
    if (v.length >= 1) {
      search({
        variables: {
          search: `%${v}%`,
        },
      });
    }
  };

  if (value.name === '') {
    return (
      <div className='relative'>
        <Input
          id={id}
          name={id}
          value={searchValue}
          onChange={(e) => handleSearch(e.target.value)}
        />
        {searchValue !== '' && data?.products?.length > 0 ? (
          <section
            className={`absolute top-full mt-0.5 w-full text-base border ring-yellow-default border-yellow-default sm:text-sm rounded-md bg-white shadow`}>
            <ul>
              {data.products.map((p) => (
                <li key={`single_product_selector${p.id}`}>
                  <button
                    onClick={() =>
                      setValue({
                        id: p.id,
                        name: p.title,
                        price: p.price,
                      })
                    }
                    type='button'
                    className='hover:bg-blueGray-200 hover:bg-opacity-50 px-2 py-1 cursor-pointer w-full text-left
                  '>
                    {p.title}
                  </button>
                </li>
              ))}
            </ul>
          </section>
        ) : loading ? (
          <section className={`absolute top-full ${inputClassNames}`}>
            <Spinner />
          </section>
        ) : searchValue !== '' && data?.products?.length === 0 ? (
          <section className={`absolute top-full ${inputClassNames}`}>
            No Results
          </section>
        ) : null}
      </div>
    );
  } else {
    return (
      <div className=' h-full flex flex-row justify-between border-b border-gray-300 pb-1 px-2 -mb-4'>
        <span>{value.name}</span>
        <button
          type='button'
          onClick={() => {
            setValue({ name: '', id: '', price: 0 });
            setSearchValue('');
          }}
          className='flex'>
          <svg
            className='w-4 h-4 mt-auto text-gray-500 float-right hover:text-red-default'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 20 20'
            fill='currentColor'>
            <path
              fillRule='evenodd'
              d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
              clipRule='evenodd'
            />
            <title>remove</title>
          </svg>
          <span className='sr-only'>Remove</span>
        </button>
      </div>
    );
  }
};
